import { List, Map } from 'immutable';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as m, PodcastKeys } from './constants';
import * as D from './deps';

export function getPodcastState(state) {
  return state.podcast || Map();
}

export function getPodcastEpisodeProgressById(state, episodeId) {
  return getPodcastState(state).getIn([PodcastKeys.PROGRESS, episodeId], Map());
}

export function getPodcastProgramBadgeStatusById(state, programId) {
  return getPodcastState(state).getIn([PodcastKeys.NEW_EPISODE_BADGE, programId], Map());
}

export function getPodcastProgramDetailsById(state, programId) {
  return getPodcastState(state).getIn([PodcastKeys.USER_PROGRAM_DETAILS, programId], Map());
}

export function getPodcastProgramAllThumbsEpisodeList(state) {
  return getPodcastState(state).getIn([PodcastKeys.THUMBED_EPISODES], List());
}

export function getProgramBackstageAllEpisodesWithLabels(state) {
  return getPodcastState(state).get(PodcastKeys.EPISODES_WITH_LABELS, List());
}

export function getActiveBackstageProgramId(state) {
  return getPodcastState(state).get(PodcastKeys.ACTIVE_BACKSTAGE_PROGRAM_ID, '');
}

export function getPodcastIdsShouldRefreshMetadata(state, podcastIds) {
  const filteredIds = podcastIds.filter(id => {
    let metadata = getPodcastEpisodeProgressById(state, id);
    metadata = metadata.isEmpty() ? getPodcastProgramBadgeStatusById(state, id) : metadata;
    const expirationTime = metadata.get('expirationTime');
    return !expirationTime || D.Utils.Time.hasTimestampExpired(expirationTime);
  });
  return filteredIds;
}

export function areEpisodesIdsAnnotated(state, episodeIds) {
  if (!episodeIds) return false;
  const idsNeedingAnnotations = D.Utils.Entity.getPandoraIdsWithoutAnnotations(state, episodeIds);
  return idsNeedingAnnotations.size === 0;
}

export function getActiveThumbedEpisodeType(state) {
  const currentPath = D.Utils.Route.getCurrentPathnameFromState(state);
  const isThumbedUpEpisodePath = D.Utils.Route.isBackstagePodcastThumbedUpEpisodesPath(currentPath);
  const isThumbedDownEpisodePath =
    D.Utils.Route.isBackstagePodcastThumbedDownEpisodesPath(currentPath);

  if (isThumbedUpEpisodePath) {
    return D.Constants.Thumbs.THUMB_TYPES.UP;
  } else if (isThumbedDownEpisodePath) {
    return D.Constants.Thumbs.THUMB_TYPES.DOWN;
  }

  return null;
}

export function getThumbedEpisodesEmptyText(activeThumb) {
  return activeThumb === D.Constants.Thumbs.THUMB_TYPES.UP ? (
    <FormattedMessage {...m.thumbedUpEmpty} />
  ) : (
    <FormattedMessage {...m.thumbedDownEmpty} />
  );
}

export function getThumbedEpisodesTabs(programUrl, activeThumb) {
  if (!programUrl || !activeThumb) return [];

  const thumbedUpTab = {
    label: <FormattedMessage {...m.thumbedUpEpisodes} />,
    url: D.Utils.Route.getBackstagePodcastProgramThumbedUpEpisodesPath(programUrl),
    isActive: activeThumb === D.Constants.Thumbs.THUMB_TYPES.UP,
  };
  const thumbedDownTab = {
    label: <FormattedMessage {...m.thumbedDownEpisodes} />,
    url: D.Utils.Route.getBackstagePodcastProgramThumbedDownEpisodesPath(programUrl),
    isActive: activeThumb === D.Constants.Thumbs.THUMB_TYPES.DOWN,
  };

  return [thumbedUpTab, thumbedDownTab];
}

export function shouldPodcastShowNewBadge(state, programId) {
  const badgeObj = getPodcastProgramBadgeStatusById(state, programId);
  return !badgeObj.get('backstageVisited', false) && badgeObj.get('showBadge', false);
}
